var map = {
	"./1ed_list.svg": "1536",
	"./1ed_teacher.svg": "2797",
	"./1ed_timer.svg": "a7d9",
	"./9ta_docs.svg": "ca91",
	"./about.jpg": "a46c",
	"./about1.jpg": "2a2e",
	"./about2.jpg": "14ca",
	"./about3.jpg": "6a62",
	"./card1.jpg": "1de5",
	"./card10.jpg": "786d",
	"./card11.jpg": "6fbb",
	"./card12.jpg": "ebb7",
	"./card13.jpg": "71fb",
	"./card2.jpg": "737f",
	"./card3.jpg": "9deb",
	"./card4.jpg": "e7be",
	"./card5.jpg": "75a5",
	"./card6.jpg": "faf0",
	"./card7.jpg": "8041",
	"./card8.jpg": "e59d",
	"./card9.jpg": "6b42",
	"./kideducate_test.svg": "c429",
	"./logoksai-old.png": "9e37",
	"./logoksai.png": "bb69",
	"./medicos.jpg": "ea59",
	"./ok.svg": "76a5",
	"./slider_banner_1.jpg": "5e49",
	"./slider_banner_2(old).jpg": "a78e",
	"./slider_banner_2.jpg": "98ea",
	"./slider_banner_3.jpg": "e1af",
	"./slider_comments_1.jpg": "3647",
	"./slider_comments_2.jpg": "21b1",
	"./slider_comments_3.jpg": "7835",
	"./slider_comments_4.jpg": "d68e",
	"./slider_comments_5.jpg": "bdbb",
	"./slider_comments_6.jpg": "b1a0",
	"./slider_galery_1.jpg": "68c2",
	"./slider_galery_10.jpg": "4fe8",
	"./slider_galery_11.jpg": "19ec",
	"./slider_galery_12.jpg": "d399",
	"./slider_galery_13.jpg": "47c9",
	"./slider_galery_14.jpg": "6402",
	"./slider_galery_15.jpg": "2a1e",
	"./slider_galery_16.jpg": "1c8e",
	"./slider_galery_17.jpg": "3ee4",
	"./slider_galery_18.jpg": "277c",
	"./slider_galery_19.jpg": "506f",
	"./slider_galery_2.jpg": "0a87",
	"./slider_galery_20.jpg": "6ff1",
	"./slider_galery_21.jpg": "8ffd",
	"./slider_galery_22.jpg": "3e08",
	"./slider_galery_23.jpg": "f83e",
	"./slider_galery_24.jpg": "01ba",
	"./slider_galery_25.jpg": "80c9",
	"./slider_galery_26.jpg": "7705",
	"./slider_galery_27.jpg": "97c5",
	"./slider_galery_3.jpg": "a5e0",
	"./slider_galery_4.jpg": "522f",
	"./slider_galery_5.jpg": "dcdc",
	"./slider_galery_6.jpg": "6368",
	"./slider_galery_7.jpg": "f1b5",
	"./slider_galery_8.jpg": "ca26",
	"./slider_galery_9.jpg": "0b3d",
	"./touragency_guide.svg": "1e88",
	"./touragency_plane.svg": "7f3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";